import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollTop = () => {
  // Extracts pathname property(key) from an object
  const { pathname } = useLocation();

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  // Return null or empty element to satisfy the requirement of returning JSX
  return null;
};

export default ScrollTop;
